// ===============================
// 1. ХРАНИЛИЩЕ НЕСКОЛЬКИХ БОКСОВ (truffles / madeleines)
// ===============================
(function (window) {
  var STORAGE_KEY = 'matchesBoxMulti';
  var DEFAULT_MAX_ITEMS = 9;
  var MADELEINES_MAX_ITEMS = 10;

  function normalizeBoxKey(key) {
    if (!key) return 'default';
    return String(key).toLowerCase();
  }

  function getMaxItemsForKey(key) {
    var normalizedKey = normalizeBoxKey(key);
    if (normalizedKey.indexOf('madeleine') !== -1) {
      return MADELEINES_MAX_ITEMS;
    }
    return DEFAULT_MAX_ITEMS;
  }

  function getCurrentMaxItems() {
    return getMaxItemsForKey(getCurrentBoxKey());
  }

  // state = { currentBoxKey: 'truffles', boxes: { truffles: { items, total }, madeleines: {...} } }
  var state = loadState() || createEmptyState();

  function createEmptyState() {
    return {
      currentBoxKey: 'default',
      boxes: {
        default: { items: {}, total: 0 }
      }
    };
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.boxes || typeof parsed.boxes !== 'object') return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function ensureBox(key) {
    var normalizedKey = normalizeBoxKey(key);
    if (!state.boxes[normalizedKey]) {
      state.boxes[normalizedKey] = { items: {}, total: 0 };
    }
  }

  function getCurrentBoxKey() {
    return normalizeBoxKey(state.currentBoxKey || 'default');
  }

  function setCurrentBoxKey(key) {
    state.currentBoxKey = normalizeBoxKey(key);
    ensureBox(state.currentBoxKey);
    saveState();
  }

  function getCurrentBox() {
    var key = getCurrentBoxKey();
    ensureBox(key);
    return state.boxes[key];
  }

  function recalcTotal() {
    var box = getCurrentBox();
    var total = 0;
    for (var id in box.items) {
      if (!box.items.hasOwnProperty(id)) continue;
      var qty = parseInt(box.items[id].qty, 10) || 0;
      total += qty;
    }
    box.total = total;
  }

  function getTotal() {
    var box = getCurrentBox();
    return box.total || 0;
  }

  function getItemQty(id) {
    var box = getCurrentBox();
    var row = box.items[id];
    return row ? row.qty : 0;
  }

  function setItemQty(id, title, variantId, qty) {
    var box = getCurrentBox();

    qty = Math.max(0, Math.floor(qty));

    var current = box.items[id] ? box.items[id].qty : 0;
    var newTotal = box.total + (qty - current);

    if (newTotal > getCurrentMaxItems()) {
      return { ok: false, reason: 'full', total: box.total };
    }

    if (qty === 0) {
      delete box.items[id];
    } else {
      box.items[id] = {
        qty: qty,
        title: title,
        variantId: variantId
      };
    }

    recalcTotal();
    saveState();

    return { ok: true, total: box.total, qty: qty };
  }

  function addOne(id, title, variantId) {
    var current = getItemQty(id);
    return setItemQty(id, title, variantId, current + 1);
  }

  function getCompositionArray() {
    var box = getCurrentBox();
    var result = [];
    for (var id in box.items) {
      if (!box.items.hasOwnProperty(id)) continue;
      var row = box.items[id];
      result.push({
        id: id,
        title: row.title,
        variantId: row.variantId,
        qty: row.qty
      });
    }
    return result;
  }

  function reset() {
    var key = getCurrentBoxKey();
    state.boxes[key] = { items: {}, total: 0 };
    saveState();
  }

  function resetAll() {
    state = createEmptyState();
    saveState();
  }

  window.MatchesBox = {
    get MAX_ITEMS() {
      return getCurrentMaxItems();
    },
    getMaxItems: getCurrentMaxItems,
    setBoxKey: setCurrentBoxKey,
    getBoxKey: getCurrentBoxKey,
    getMaxItemsForKey: getMaxItemsForKey,
    getTotal: getTotal,
    getItemQty: getItemQty,
    setItemQty: setItemQty,
    addOne: addOne,
    getCompositionArray: getCompositionArray,
    reset: reset,
    resetAll: resetAll
  };
})(window);


// ===============================
// 2. СТРАНИЦА TRUFFLES BOX
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  if (!window.MatchesBox) return;

  var section = document.querySelector('[data-section-type="truffles-box"]');
  if (!section) return;

  // какой бокс: truffles / madeleines
  var boxKeyAttr = section.getAttribute('data-box-key') || 'truffles';
  if (typeof window.MatchesBox.setBoxKey === 'function') {
    window.MatchesBox.setBoxKey(boxKeyAttr);
  }


    // --- сколько каждого variant_id уже лежит в корзине ---
  var cartVariantTotals = {};

  function loadCartVariantTotals() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartVariantTotals = {};
        if (!cart || !cart.items) return;

        cart.items.forEach(function (item) {
          if (!item.variant_id) return;
          var key = String(item.variant_id);
          cartVariantTotals[key] = (cartVariantTotals[key] || 0) + item.quantity;
        });
      })
      .catch(function (err) {
        console.error('cart totals error', err);
        cartVariantTotals = {};
      });
  }

  function getVariantUsedQty(variantId) {
    return cartVariantTotals[String(variantId)] || 0;
  }

  // грузим корзину при открытии страницы
  loadCartVariantTotals();


  var cards      = section.querySelectorAll('.SingelTruffles-item');
  if (!cards.length) return;

  var totalSpan = section.querySelector('[data-truffles-count]') || section.querySelector('.truffles-cont span');

  var popup         = section.querySelector('.box-full-overlay');
  var popupClose    = popup ? popup.querySelector('.box-full-close') : null;
  var popupAddAnother = popup ? popup.querySelector('.box-full-add-another') : null;
  var infoOverlay   = section.querySelector('[data-truffle-info-overlay]');
  var infoClose     = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-close]') : null;
  var infoImage     = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-image]') : null;
  var infoPrevBtn   = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-prev]') : null;
  var infoNextBtn   = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-next]') : null;
  var infoDots      = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-dots]') : null;
  var infoTitle     = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-title]') : null;
  var infoDescription = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-description]') : null;
  var infoNutrition = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-nutrition]') : null;
  var infoAddBtn    = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-add]') : null;
  var infoCount     = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-count]') : null;
  var infoTabs      = infoOverlay ? infoOverlay.querySelectorAll('[data-truffle-info-tab]') : [];
  var infoTabContents = infoOverlay ? infoOverlay.querySelectorAll('[data-truffle-info-content]') : [];
  var infoNutritionTab = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-tab="nutrition"]') : null;
  var infoDescriptionTab = infoOverlay ? infoOverlay.querySelector('[data-truffle-info-tab="description"]') : null;
  var infoCurrentCard = null;
  var infoGalleryItems = [];
  var infoGalleryIndex = 0;

  function clampFlavorLevel(level) {
    var n = parseInt(level, 10);
    if (isNaN(n)) n = 0;
    if (n < 0) n = 0;
    if (n > 2) n = 2;
    return n;
  }

  function setFlavorScale(type, level) {
    if (!infoOverlay) return;
    var el = infoOverlay.querySelector('[data-truffle-info-scale="' + type + '"]');
    if (!el) return;
    var normalized = clampFlavorLevel(level);
    el.classList.remove('level-0', 'level-1', 'level-2');
    el.classList.add('level-' + normalized);
  }

  function normalizeTextureLevel(raw) {
    var value = String(raw || '').trim().toLowerCase();
    if (!value) return 0;

    var numericMatch = value.match(/-?\d+/);
    if (numericMatch) {
      return clampFlavorLevel(parseInt(numericMatch[0], 10));
    }

    if (value === 'smooth' || value === 'soft' || value === 'silky') return 0;
    if (value === 'medium' || value === 'balanced' || value === 'creamy') return 1;
    if (value === 'firm' || value === 'hard' || value === 'crunchy' || value === 'crispy' || value === 'rough') return 2;

    return 0;
  }

  function switchInfoTab(tabName) {
    if (!infoOverlay) return;
    infoTabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-truffle-info-tab') === tabName;
      tab.classList.toggle('is-active', isActive);
    });
    infoTabContents.forEach(function (content) {
      var isActive = content.getAttribute('data-truffle-info-content') === tabName;
      content.classList.toggle('is-active', isActive);
    });
  }

  function refreshInfoAddButtonText() {
    if (!infoCount) return;
    infoCount.textContent = window.MatchesBox.getTotal() + '/' + window.MatchesBox.MAX_ITEMS;
  }

  function collectInfoGalleryItems(card) {
    if (!card) return [];

    var items = [];
    var galleryNodes = card.querySelectorAll('[data-info-gallery-src]');

    galleryNodes.forEach(function (node) {
      var src = node.getAttribute('data-info-gallery-src') || '';
      if (!src) return;
      items.push({
        src: src,
        alt: node.getAttribute('data-info-gallery-alt') || ''
      });
    });

    if (!items.length) {
      var fallbackSrc = card.getAttribute('data-info-image-url') || '';
      if (fallbackSrc) {
        items.push({
          src: fallbackSrc,
          alt: card.getAttribute('data-info-image-alt') || ''
        });
      }
    }

    return items;
  }

  function renderInfoGallery() {
    if (!infoImage) return;

    if (!infoGalleryItems.length) {
      infoImage.src = '';
      infoImage.alt = '';
      if (infoPrevBtn) infoPrevBtn.style.display = 'none';
      if (infoNextBtn) infoNextBtn.style.display = 'none';
      if (infoDots) infoDots.innerHTML = '';
      return;
    }

    if (infoGalleryIndex < 0 || infoGalleryIndex >= infoGalleryItems.length) {
      infoGalleryIndex = 0;
    }

    var current = infoGalleryItems[infoGalleryIndex];
    infoImage.src = current.src || '';
    infoImage.alt = current.alt || '';

    var isMulti = infoGalleryItems.length > 1;
    if (infoPrevBtn) {
      infoPrevBtn.style.display = isMulti ? '' : 'none';
      infoPrevBtn.disabled = !isMulti;
    }
    if (infoNextBtn) {
      infoNextBtn.style.display = isMulti ? '' : 'none';
      infoNextBtn.disabled = !isMulti;
    }

    if (!infoDots) return;
    infoDots.innerHTML = '';
    if (!isMulti) return;

    infoGalleryItems.forEach(function (_, idx) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'truffle-info-gallery-dot' + (idx === infoGalleryIndex ? ' is-active' : '');
      dot.setAttribute('data-truffle-info-dot', String(idx));
      dot.setAttribute('aria-label', 'View image ' + (idx + 1));
      infoDots.appendChild(dot);
    });
  }

  function setInfoGalleryIndex(nextIndex) {
    if (!infoGalleryItems.length) return;
    var len = infoGalleryItems.length;
    infoGalleryIndex = ((nextIndex % len) + len) % len;
    renderInfoGallery();
  }

  function closeInfoModal() {
    if (!infoOverlay) return;
    infoOverlay.classList.remove('is-open');
    infoCurrentCard = null;
    infoGalleryItems = [];
    infoGalleryIndex = 0;
  }

  function openInfoModal(card) {
    if (!infoOverlay || !card) return;
    infoCurrentCard = card;

    if (infoTitle) {
      infoTitle.textContent = card.getAttribute('data-info-title') || '';
    }

    if (infoDescription) {
      var desc = card.getAttribute('data-info-description') || '';
      infoDescription.textContent = desc || 'Description coming soon.';
    }

    if (infoNutrition) {
      infoNutrition.textContent = card.getAttribute('data-info-nutrition') || '';
    }

    infoGalleryItems = collectInfoGalleryItems(card);
    infoGalleryIndex = 0;
    renderInfoGallery();

    setFlavorScale('sweetness', card.getAttribute('data-info-sweetness'));
    setFlavorScale('acidity', card.getAttribute('data-info-acidity'));
    setFlavorScale('fruitiness', card.getAttribute('data-info-fruitiness'));
    setFlavorScale('nuttiness', card.getAttribute('data-info-nuttiness'));
    setFlavorScale('texture', normalizeTextureLevel(card.getAttribute('data-info-texture')));

    if (infoNutritionTab) {
      infoNutritionTab.style.display = '';
    }
    if (infoDescriptionTab) {
      infoDescriptionTab.style.width = '';
    }
    switchInfoTab('description');

    if (infoAddBtn) {
      var isAvailable = card.getAttribute('data-info-available') === '1' && !card.classList.contains('is-out-of-stock');
      infoAddBtn.disabled = !isAvailable;
      infoAddBtn.style.display = isAvailable ? '' : 'none';
    }

    refreshInfoAddButtonText();
    infoOverlay.classList.add('is-open');
  }

  // --- ID варианта PACK TRUFFLES (boxVariantId) ---
  var boxVariantId = null;

  (function resolveBoxVariantId() {
    // 1) из скрытого конфига в секции
    var cfgEl = section.querySelector('.truffles-box-config[data-box-variant-id]');
    if (cfgEl) {
      var attr = cfgEl.getAttribute('data-box-variant-id');
      if (attr) {
        boxVariantId = parseInt(attr, 10) || null;
      }
    }

    // 2) из глобальной переменной (inline <script> в Liquid)
    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromGlobals(boxKeyAttr);
    }

    // 3) из localStorage (на всякий случай)
    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromStorage(boxKeyAttr);
    }
  })();


  function updateTotalUI() {
    var total = window.MatchesBox.getTotal();
    if (totalSpan) {
      totalSpan.textContent = total + '/' + window.MatchesBox.MAX_ITEMS;
    }
    refreshInfoAddButtonText();
  }

  function isBoxComplete() {
    return window.MatchesBox.getTotal() === window.MatchesBox.MAX_ITEMS;
  }

  function openFullPopup() {
    closeInfoModal();
    if (popup) popup.classList.add('is-open');
    else alert('YOUR BOX IS FULL');
  }

  function closeFullPopup() {
    if (popup) popup.classList.remove('is-open');
  }

  if (popupClose) {
    popupClose.addEventListener('click', closeFullPopup);
  }

  if (infoClose) {
    infoClose.addEventListener('click', closeInfoModal);
  }

  if (infoOverlay) {
    infoOverlay.addEventListener('click', function (e) {
      if (e.target === infoOverlay) {
        closeInfoModal();
      }
    });
  }

  if (infoTabs && infoTabs.length) {
    infoTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabName = tab.getAttribute('data-truffle-info-tab') || 'description';
        switchInfoTab(tabName);
      });
    });
  }

  if (infoPrevBtn) {
    infoPrevBtn.addEventListener('click', function () {
      setInfoGalleryIndex(infoGalleryIndex - 1);
    });
  }

  if (infoNextBtn) {
    infoNextBtn.addEventListener('click', function () {
      setInfoGalleryIndex(infoGalleryIndex + 1);
    });
  }

  if (infoDots) {
    infoDots.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-truffle-info-dot]');
      if (!dot) return;
      var idx = parseInt(dot.getAttribute('data-truffle-info-dot'), 10);
      if (isNaN(idx)) return;
      setInfoGalleryIndex(idx);
    });
  }

//   if (popupAddAnother) {
//     popupAddAnother.addEventListener('click', function () {
//         window.MatchesBox.reset();
//         cards.forEach(syncCardFromStorage);
//         updateTotalUI();
//         closeFullPopup();
//     });
//     }

  function getCardId(card) {
    var fromAttr = card.getAttribute('data-truffle-id');
    if (fromAttr) return fromAttr;
    var titleEl = card.querySelector('.SingelTruffles-item-title');
    return titleEl
      ? titleEl.textContent.trim().toLowerCase().replace(/\s+/g, '-')
      : '';
  }

  function getCardTitle(card) {
    var titleEl = card.querySelector('.SingelTruffles-item-title');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function getCardVariantId(card) {
    var attr = card.getAttribute('data-truffle-variant-id');
    if (!attr) return null;
    var vid = parseInt(attr, 10);
    return isNaN(vid) ? null : vid;
  }

  function syncCardFromStorage(card) {
    if (card.classList.contains('is-out-of-stock')) return;

    var id       = getCardId(card);
    var addBtn   = card.querySelector('.SingelTruffles-add-btn');
    var qtyWrap  = card.querySelector('.SingelTruffles-qty');
    var minusBtn = card.querySelector('.SingelTruffles-qty-minus');
    var plusBtn  = card.querySelector('.SingelTruffles-qty-plus');
    var valueEl  = card.querySelector('.SingelTruffles-qty-value');

    if (!addBtn || !qtyWrap || !minusBtn || !plusBtn || !valueEl) return;

    var qty = window.MatchesBox.getItemQty(id);

    if (qty <= 0) {
      addBtn.style.display  = 'block';
      qtyWrap.style.display = 'none';
      valueEl.textContent   = '1';
    } else {
      addBtn.style.display  = 'none';
      qtyWrap.style.display = 'flex';
      valueEl.textContent   = qty;
    }
  }

  // Обработчики на карточках
  cards.forEach(function (card) {
    if (card.classList.contains('is-out-of-stock')) return;

    var openTriggers = card.querySelectorAll('.SingelTruffles-item-open');
    if (!openTriggers.length) return;

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openInfoModal(card);
      });
    });
  });

if (infoAddBtn) {
  infoAddBtn.addEventListener('click', function () {
    if (!infoCurrentCard) return;
    var targetCard = infoCurrentCard;
    if (targetCard.classList.contains('is-out-of-stock')) return;
    if (window.MatchesBox.getTotal() >= window.MatchesBox.MAX_ITEMS) {
      closeInfoModal();
      openFullPopup();
      return;
    }
    if (typeof targetCard.__matchesAddOne !== 'function') return;

    var willBeFull = window.MatchesBox.getTotal() + 1 >= window.MatchesBox.MAX_ITEMS;
    if (willBeFull) {
      closeInfoModal();
    }

    targetCard.__matchesAddOne();
    refreshInfoAddButtonText();
  });
}

cards.forEach(function (card) {
    if (card.classList.contains('is-out-of-stock')) return;

    var id        = getCardId(card);
    if (!id) return;

    var title     = getCardTitle(card);
    var variantId = getCardVariantId(card);

    var addBtn   = card.querySelector('.SingelTruffles-add-btn');
    var qtyWrap  = card.querySelector('.SingelTruffles-qty');
    var minusBtn = card.querySelector('.SingelTruffles-qty-minus');
    var plusBtn  = card.querySelector('.SingelTruffles-qty-plus');
    var valueEl  = card.querySelector('.SingelTruffles-qty-value');

    if (!addBtn || !qtyWrap || !minusBtn || !plusBtn || !valueEl) return;

    syncCardFromStorage(card);

        // можно ли добавить ЕЩЁ 1 этот трюфель,
    // учитывая:
    //  - сколько его уже в корзине во всех боксах и одиночных
    //  - сколько этого трюфеля уже выбрали в текущем боксе
    //  - общий остаток variant_id (data-max-stock)
    function canAddOneMore() {
      if (!variantId) return true;

      var maxStockAttr = card.getAttribute('data-max-stock');
      var maxStock = parseInt(maxStockAttr, 10);

      // если остаток не отслеживается — не ограничиваем
      if (!maxStockAttr || isNaN(maxStock)) {
        return true;
      }

      var alreadyInCart = getVariantUsedQty(variantId);          // все боксы + single в корзине
      var inCurrentBox  = window.MatchesBox.getItemQty(id) || 0; // сколько выбрали в этом боксе
      var totalIfAddOne = alreadyInCart + inCurrentBox + 1;

      return totalIfAddOne <= maxStock;
    }

    function handleAddOne() {
        if (!canAddOneMore()) {
            // вместо alert просто блокируем кнопки
            if (addBtn)  addBtn.disabled = true;
            if (plusBtn) plusBtn.disabled = true;

            // опционально — визуальный класс, чтобы подсветить, что трюфель "выбран весь"
            card.classList.add('SingelTruffles-item--no-more-stock');
            return;
        }

        var res = window.MatchesBox.addOne(id, title, variantId);
        if (!res.ok && res.reason === 'full') {
            openFullPopup();
            return;
        }

        syncCardFromStorage(card);
        updateTotalUI();

        if (res.total === window.MatchesBox.MAX_ITEMS) {
            openFullPopup();
        }
        }

    card.__matchesAddOne = handleAddOne;


    addBtn.addEventListener('click', handleAddOne);
    plusBtn.addEventListener('click', handleAddOne);

    minusBtn.addEventListener('click', function () {
        var currentQty = window.MatchesBox.getItemQty(id);
        var newQty     = Math.max(0, currentQty - 1);
        window.MatchesBox.setItemQty(id, title, variantId, newQty);
        syncCardFromStorage(card);
        updateTotalUI();
        if (!isBoxComplete()) {
          closeFullPopup();
        }

        // при уменьшении числа снова даём возможность нажимать +
        if (addBtn)  addBtn.disabled = false;
        if (plusBtn) plusBtn.disabled = false;
        card.classList.remove('SingelTruffles-item--no-more-stock');
    });


  });

  cards.forEach(syncCardFromStorage);
  updateTotalUI();
  if (isBoxComplete()) {
    openFullPopup();
  }

  // --- общий helper: добавить текущий box в корзину ---
  function addCurrentBoxToCart(options) {
    options = options || {};
    var redirectToCart  = !!options.redirectToCart;  // перейти в корзину
    var closePopupAfter = !!options.closePopup;      // close popup
    var total = window.MatchesBox.getTotal();

    if (total !== window.MatchesBox.MAX_ITEMS) {
      return;
    }

    var composition = window.MatchesBox.getCompositionArray();
    if (!composition.length) {
      return;
    }

    if (!boxVariantId) {
      alert('Box product is not configured');
      return;
    }

    // массив позиций для /cart/add.js
    var items = [];

    // уникальный id коробки
    var boxId =
      'box-' +
      Date.now() +
      '-' +
      Math.floor(Math.random() * 100000);

    // 1) PACK TRUFFLES с _box_id и списком трюфелей
    var boxProps = {
      _box_builder: '1',
      _box_id: boxId
    };

    composition.forEach(function (row) {
      boxProps[row.title] = String(row.qty);
    });

    items.push({
      id: boxVariantId,
      quantity: 1,
      properties: boxProps
    });

    // 2) single-truffles с тем же _box_id
    composition.forEach(function (row) {
      if (!row.variantId) return;

      items.push({
        id: row.variantId,
        quantity: row.qty,
        properties: {
          _box_builder: '1',
          _box_id: boxId,
          truffle_title: row.title
        }
      });
    });

    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            // 1. Обновляем локальные остатки по корзине
            cartVariantTotals = {};
            if (cart && cart.items) {
            cart.items.forEach(function (item) {
                if (!item.variant_id) return;
                var key = String(item.variant_id);
                cartVariantTotals[key] = (cartVariantTotals[key] || 0) + item.quantity;
            });
            }

            // 2. Очищаем конструктор
            window.MatchesBox.reset();
            cards.forEach(syncCardFromStorage);
            updateTotalUI();

            // 3. Закрыть попап / перейти в cart, если надо
            if (closePopupAfter) {
            closeFullPopup();
            }

            if (redirectToCart) {
            window.location.href = '/cart';
            }
        })
        .catch(function (err) {
            console.error('add box error', err);
            alert('Something went wrong while adding box');
        });

  }

  // --- Кнопка внизу "ADD BOX TO CART" (как раньше: добавить и перейти в корзину) ---

  // --- Кнопка в попапе "ADD ANOTHER BOX" ---

    if (popupAddAnother) {
    popupAddAnother.addEventListener('click', function () {
        addCurrentBoxToCart({
        redirectToCart: true,   // было false
        closePopup: true        // можно оставить true, всё равно сразу уйдём на cart
        });
    });
    }



});


var MATCHES_BOX_VARIANT_STORAGE_KEY = 'matchesBoxBoxVariantId';
var MATCHES_BOX_VARIANT_MAP_STORAGE_KEY = 'matchesBoxBoxVariantIdMap';

function normalizeMatchesBoxKey(key) {
  if (!key) return 'truffles';
  return String(key).toLowerCase();
}

function readMatchesBoxVariantMapFromStorage() {
  try {
    var raw = localStorage.getItem(MATCHES_BOX_VARIANT_MAP_STORAGE_KEY);
    if (!raw) return {};
    var parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  } catch (e) {
    return {};
  }
}

function resolveBoxVariantIdFromGlobals(boxKey) {
  var normalizedKey = normalizeMatchesBoxKey(boxKey);

  if (window.MATCHES_BOX_VARIANT_IDS && typeof window.MATCHES_BOX_VARIANT_IDS === 'object') {
    var fromMap = parseInt(window.MATCHES_BOX_VARIANT_IDS[normalizedKey], 10);
    if (!isNaN(fromMap)) return fromMap;
  }

  if (typeof window.MATCHES_BOX_VARIANT_ID !== 'undefined') {
    var fromGlobal = parseInt(window.MATCHES_BOX_VARIANT_ID, 10);
    if (!isNaN(fromGlobal)) return fromGlobal;
  }

  return null;
}

function resolveBoxVariantIdFromStorage(boxKey) {
  var normalizedKey = normalizeMatchesBoxKey(boxKey);

  var map = readMatchesBoxVariantMapFromStorage();
  var fromMap = parseInt(map[normalizedKey], 10);
  if (!isNaN(fromMap)) {
    return fromMap;
  }

  try {
    var legacy = localStorage.getItem(MATCHES_BOX_VARIANT_STORAGE_KEY);
    if (!legacy) return null;
    var fromLegacy = parseInt(legacy, 10);
    if (!isNaN(fromLegacy)) return fromLegacy;
  } catch (e) {}

  return null;
}

// ===============================
// 3. HOME TRUFFLES SECTION
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  if (!window.MatchesBox) return;

  var section = document.querySelector('[data-section-type="matches-home-truffles"]');
  if (!section) return;

  var boxKeyAttr = section.getAttribute('data-box-key') || 'truffles';
  if (typeof window.MatchesBox.setBoxKey === 'function') {
    window.MatchesBox.setBoxKey(boxKeyAttr);
  }

  var cards = section.querySelectorAll('.truffles-item');
  if (!cards.length) return;

  var totalSpan = section.querySelector('[data-home-truffles-count]');
  var popup = section.querySelector('.box-full-overlay');
  var popupClose = popup ? popup.querySelector('.box-full-close') : null;
  var popupAddAnother = popup ? popup.querySelector('.box-full-add-another') : null;
  var boxVariantId = null;
  var cartVariantTotals = {};

  function resolveBoxVariantId() {
    var cfgEl = section.querySelector('.matches-home-box-config[data-box-variant-id]');
    if (cfgEl) {
      var attr = cfgEl.getAttribute('data-box-variant-id');
      if (attr) {
        boxVariantId = parseInt(attr, 10) || null;
      }
    }

    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromGlobals(boxKeyAttr);
    }

    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromStorage(boxKeyAttr);
    }
  }

  function loadCartVariantTotals() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartVariantTotals = {};
        if (!cart || !cart.items) return;

        cart.items.forEach(function (item) {
          if (!item.variant_id) return;
          var key = String(item.variant_id);
          cartVariantTotals[key] = (cartVariantTotals[key] || 0) + item.quantity;
        });
      })
      .catch(function () {
        cartVariantTotals = {};
      });
  }

  function getVariantUsedQty(variantId) {
    return cartVariantTotals[String(variantId)] || 0;
  }

  function updateTotalUI() {
    if (!totalSpan) return;
    var total = window.MatchesBox.getTotal();
    totalSpan.textContent = total + '/' + window.MatchesBox.MAX_ITEMS;
  }

  function isBoxComplete() {
    return window.MatchesBox.getTotal() === window.MatchesBox.MAX_ITEMS;
  }

  function openFullPopup() {
    if (popup) popup.classList.add('is-open');
  }

  function closeFullPopup() {
    if (popup) popup.classList.remove('is-open');
  }

  function getCardId(card) {
    var fromAttr = card.getAttribute('data-truffle-id');
    if (fromAttr) return fromAttr;
    var titleEl = card.querySelector('.truffles-item-title');
    return titleEl ? titleEl.textContent.trim().toLowerCase().replace(/\s+/g, '-') : '';
  }

  function getCardTitle(card) {
    var titleEl = card.querySelector('.truffles-item-title');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function getCardVariantId(card) {
    var attr = card.getAttribute('data-truffle-variant-id');
    if (!attr) return null;
    var vid = parseInt(attr, 10);
    return isNaN(vid) ? null : vid;
  }

  function syncCardFromStorage(card) {
    if (card.classList.contains('is-out-of-stock')) return;

    var id = getCardId(card);
    var addBtn = card.querySelector('.truffles-item-add-btn');
    var qtyWrap = card.querySelector('.truffles-item-qty');
    var minusBtn = card.querySelector('.truffles-item-qty-minus');
    var plusBtn = card.querySelector('.truffles-item-qty-plus');
    var valueEl = card.querySelector('.truffles-item-qty-value');

    if (!addBtn || !qtyWrap || !minusBtn || !plusBtn || !valueEl) return;

    var qty = window.MatchesBox.getItemQty(id);

    if (qty <= 0) {
      addBtn.style.display = 'block';
      qtyWrap.style.display = 'none';
      valueEl.textContent = '1';
    } else {
      addBtn.style.display = 'none';
      qtyWrap.style.display = 'flex';
      valueEl.textContent = qty;
    }
  }

  function addCurrentBoxToCart(options) {
    options = options || {};
    var redirectToCart = !!options.redirectToCart;
    var closePopupAfter = !!options.closePopup;
    var total = window.MatchesBox.getTotal();

    if (total !== window.MatchesBox.MAX_ITEMS) {
      return;
    }

    var composition = window.MatchesBox.getCompositionArray();
    if (!composition.length || !boxVariantId) {
      return;
    }

    var items = [];
    var boxId =
      'box-' +
      Date.now() +
      '-' +
      Math.floor(Math.random() * 100000);

    var boxProps = {
      _box_builder: '1',
      _box_id: boxId
    };

    composition.forEach(function (row) {
      boxProps[row.title] = String(row.qty);
    });

    items.push({
      id: boxVariantId,
      quantity: 1,
      properties: boxProps
    });

    composition.forEach(function (row) {
      if (!row.variantId) return;

      items.push({
        id: row.variantId,
        quantity: row.qty,
        properties: {
          _box_builder: '1',
          _box_id: boxId,
          truffle_title: row.title
        }
      });
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartVariantTotals = {};
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            if (!item.variant_id) return;
            var key = String(item.variant_id);
            cartVariantTotals[key] = (cartVariantTotals[key] || 0) + item.quantity;
          });
        }

        window.MatchesBox.reset();
        cards.forEach(syncCardFromStorage);
        updateTotalUI();

        if (closePopupAfter) {
          closeFullPopup();
        }
        if (redirectToCart) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {});
  }

  cards.forEach(function (card) {
    if (card.classList.contains('is-out-of-stock')) return;

    var id = getCardId(card);
    if (!id) return;

    var title = getCardTitle(card);
    var variantId = getCardVariantId(card);
    var addBtn = card.querySelector('.truffles-item-add-btn');
    var qtyWrap = card.querySelector('.truffles-item-qty');
    var minusBtn = card.querySelector('.truffles-item-qty-minus');
    var plusBtn = card.querySelector('.truffles-item-qty-plus');
    var valueEl = card.querySelector('.truffles-item-qty-value');

    if (!addBtn || !qtyWrap || !minusBtn || !plusBtn || !valueEl) return;

    syncCardFromStorage(card);

    function canAddOneMore() {
      if (!variantId) return true;

      var maxStockAttr = card.getAttribute('data-max-stock');
      var maxStock = parseInt(maxStockAttr, 10);
      if (!maxStockAttr || isNaN(maxStock)) {
        return true;
      }

      var alreadyInCart = getVariantUsedQty(variantId);
      var inCurrentBox = window.MatchesBox.getItemQty(id) || 0;
      var totalIfAddOne = alreadyInCart + inCurrentBox + 1;

      return totalIfAddOne <= maxStock;
    }

    function handleAddOne() {
      if (!canAddOneMore()) {
        if (addBtn) addBtn.disabled = true;
        if (plusBtn) plusBtn.disabled = true;
        card.classList.add('truffles-item--no-more-stock');
        return;
      }

      var res = window.MatchesBox.addOne(id, title, variantId);
      if (!res.ok && res.reason === 'full') {
        openFullPopup();
        return;
      }

      syncCardFromStorage(card);
      updateTotalUI();

      if (res.total === window.MatchesBox.MAX_ITEMS) {
        openFullPopup();
      }
    }

    card.__matchesAddOne = handleAddOne;

    addBtn.addEventListener('click', handleAddOne);
    plusBtn.addEventListener('click', handleAddOne);

    minusBtn.addEventListener('click', function () {
      var currentQty = window.MatchesBox.getItemQty(id);
      var newQty = Math.max(0, currentQty - 1);
      window.MatchesBox.setItemQty(id, title, variantId, newQty);
      syncCardFromStorage(card);
      updateTotalUI();

      if (!isBoxComplete()) {
        closeFullPopup();
      }

      if (addBtn) addBtn.disabled = false;
      if (plusBtn) plusBtn.disabled = false;
      card.classList.remove('truffles-item--no-more-stock');
    });
  });

  if (popupClose) {
    popupClose.addEventListener('click', closeFullPopup);
  }

  if (popupAddAnother) {
    popupAddAnother.addEventListener('click', function () {
      addCurrentBoxToCart({
        redirectToCart: true,
        closePopup: true
      });
    });
  }

  resolveBoxVariantId();
  loadCartVariantTotals();
  cards.forEach(syncCardFromStorage);
  updateTotalUI();
  if (isBoxComplete()) {
    openFullPopup();
  }
});


// ===============================
// 4. СТРАНИЦА SINGLE TRUFFLE
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  if (!window.MatchesBox) return;

  var section = document.querySelector('[data-section-type="single-truffle"]');
  if (!section) return;

  // boxKey с разметки (truffles / madeleines)
  var boxKeyAttr = section.getAttribute('data-box-key') || 'truffles';
  if (typeof window.MatchesBox.setBoxKey === 'function') {
    window.MatchesBox.setBoxKey(boxKeyAttr);
  }

  var normalizedBoxKey = normalizeMatchesBoxKey(boxKeyAttr);
  var boxBuilderUrl = normalizedBoxKey.indexOf('madeleine') !== -1
    ? '/pages/madeleines-box/'
    : '/pages/truffles-box/';
  var boxBuilderLabel = normalizedBoxKey.indexOf('madeleine') !== -1
    ? 'MADELEINES'
    : 'TRUFFLES';

  var truffleId = section.getAttribute('data-truffle-id');
  var button    = section.querySelector('.single-product-add-to-card');
  if (!button || !truffleId) return;

  // variant id + лимит по складу из data-атрибутов
  var variantIdAttr = section.getAttribute('data-truffle-variant-id');
  var variantId = variantIdAttr ? parseInt(variantIdAttr, 10) : null;

  var maxStockAttr = section.getAttribute('data-max-stock');
  var maxStock = maxStockAttr ? parseInt(maxStockAttr, 10) : null;

  var titleEl      = section.querySelector('.single-product-title');
  var truffleTitle = titleEl ? titleEl.textContent.trim() : truffleId;

  var popup          = document.querySelector('.box-full-overlay');
  var popupClose     = popup ? popup.querySelector('.box-full-close') : null;
  var popupAddButton = popup ? popup.querySelector('.box-full-add-another') : null;
  var popupMode      = 'box'; // 'box' | 'stock'

  // --- variant_id коробки (PACK TRUFFLES / MADELEINES) ---
  var boxVariantId = null;
  (function resolveBoxVariantId() {
    // 1) сначала пробуем взять из hidden-конфига на странице
    var cfgEl = section.querySelector('.single-truffle-box-config[data-box-variant-id]');
    if (cfgEl) {
      var attr = cfgEl.getAttribute('data-box-variant-id');
      if (attr) {
        var tmp = parseInt(attr, 10);
        if (!isNaN(tmp)) {
          boxVariantId = tmp;
        }
      }
    }

    // 2) fallback: глобальная переменная
    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromGlobals(boxKeyAttr);
    }

    // 3) fallback: localStorage, если вообще ничего не нашли
    if (!boxVariantId) {
      boxVariantId = resolveBoxVariantIdFromStorage(boxKeyAttr);
    }
  })();


  // --- корзина: сколько какого variant_id уже лежит в cart ---
  var cartVariantTotals = {};

  function loadCartVariantTotals() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartVariantTotals = {};
        if (!cart || !cart.items) return;

        cart.items.forEach(function (item) {
          if (!item.variant_id) return;
          var key = String(item.variant_id);
          cartVariantTotals[key] = (cartVariantTotals[key] || 0) + item.quantity;
        });
      })
      .catch(function (err) {
        console.error('cart totals error (single)', err);
        cartVariantTotals = {};
      });
  }

  function getVariantUsedQty(vid) {
    return cartVariantTotals[String(vid)] || 0;
  }

  loadCartVariantTotals();

  // сколько этого варианта уже выбрано в текущем боксе (в localStorage)
  function getVariantQtyInCurrentBox(vid) {
    var comp = window.MatchesBox.getCompositionArray();
    var total = 0;
    comp.forEach(function (row) {
      if (row.variantId === vid) total += row.qty;
    });
    return total;
  }

  // можно ли добавить ещё 1 шт. с учётом cart + текущего бокса + остатка
  function canAddOneMore() {
    if (!variantId || !maxStock || isNaN(maxStock)) return true;

    var alreadyInCart = getVariantUsedQty(variantId);
    var inCurrentBox  = getVariantQtyInCurrentBox(variantId);
    var totalIfAddOne = alreadyInCart + inCurrentBox + 1;

    return totalIfAddOne <= maxStock;
  }

  function setPopupContent(titleText, buttonText) {
    if (!popup) return;
    var titleNode = popup.querySelector('.box-full-title');
    var btnNode   = popup.querySelector('.box-full-add-another');
    if (titleNode) titleNode.textContent = titleText;
    if (btnNode)   btnNode.textContent   = buttonText;
  }

  // --- добавить текущий бокс в корзину из single-страницы ---
  function addCurrentBoxToCartFromSingle(options) {
    options = options || {};
    var redirectToCart = !!options.redirectToCart;

    var composition = window.MatchesBox.getCompositionArray();
    if (!composition.length) {
      return;
    }

    if (!boxVariantId) {
      alert('Box product is not configured');
      return;
    }

    var items = [];
    var boxId =
      'box-' +
      Date.now() +
      '-' +
      Math.floor(Math.random() * 100000);

    var boxProps = {
      _box_builder: '1',
      _box_id: boxId
    };

    composition.forEach(function (row) {
      boxProps[row.title] = String(row.qty);
    });

    items.push({
      id: boxVariantId,
      quantity: 1,
      properties: boxProps
    });

    composition.forEach(function (row) {
      if (!row.variantId) return;
      items.push({
        id: row.variantId,
        quantity: row.qty,
        properties: {
          _box_builder: '1',
          _box_id: boxId,
          truffle_title: row.title
        }
      });
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        // очищаем конструктор
        window.MatchesBox.reset();
        updateButtonState();

        if (redirectToCart) {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('add box from single error', err);
        alert('Something went wrong while adding box');
      });
  }

  // попап когда коробка полностью забита (9/9)
  function openBoxFullPopup() {
    popupMode = 'box';
    if (popup) {
      setPopupContent('YOUR BOX IS FULL', 'ADD BOX TO CART');
      popup.classList.add('is-open');
    } else {
      alert('YOUR BOX IS FULL');
    }
  }

  // попап когда НЕТ остатка на складе
  function openStockPopup() {
    popupMode = 'stock';
    if (popup) {
      setPopupContent('NOT ENOUGH STOCK FOR THIS TRUFFLE', boxBuilderLabel);
      popup.classList.add('is-open');
    } else {
      alert('Not enough stock for this truffle.');
    }
  }

  function closeFullPopup() {
    if (popup) popup.classList.remove('is-open');
  }

  if (popupClose) {
    popupClose.addEventListener('click', closeFullPopup);
  }

  if (popupAddButton) {
    popupAddButton.addEventListener('click', function () {
      if (popupMode === 'stock') {
        // кнопка "TRUFFLES" — ведём в конструктор
        window.location.href = boxBuilderUrl;
      } else if (popupMode === 'box') {
        // коробка полная — сразу добавляем бокс в корзину и переходим в cart
        addCurrentBoxToCartFromSingle({ redirectToCart: true });
      }
    });
  }

  function updateButtonState() {
    var total = window.MatchesBox.getTotal();

    if (total <= 0) {
      button.textContent = 'Add to card';
      button.classList.remove('single-product-add-to-card-exist');
    } else {
      button.textContent =
        'BUILD YOUR BOX ' + total + '/' + window.MatchesBox.MAX_ITEMS;
      button.classList.add('single-product-add-to-card-exist');
    }
  }

  button.addEventListener('click', function () {
    var total = window.MatchesBox.getTotal();

    // если уже 9/9 — сразу показываем попап добавления бокса
    if (total >= window.MatchesBox.MAX_ITEMS) {
      openBoxFullPopup();
      return;
    }

    // проверяем склад
    if (!canAddOneMore()) {
      openStockPopup();
      return;
    }

    // пробуем добавить 1 шт. в текущий бокс
    var res = window.MatchesBox.addOne(truffleId, truffleTitle, variantId);
    if (!res.ok && res.reason === 'full') {
      // коробка стала полной именно сейчас
      openBoxFullPopup();
      return;
    }

    updateButtonState();
  });

  // --- табы ---
  (function () {
    var tabTitles   = section.querySelectorAll('.single-product-desc-title');
    var tabContents = section.querySelectorAll('.single-product-desc-text');
    if (!tabTitles.length || !tabContents.length) return;

    tabTitles.forEach(function (title) {
      title.addEventListener('click', function () {
        var target = this.dataset.tab;

        tabTitles.forEach(function (t) { t.classList.remove('is-active'); });
        tabContents.forEach(function (c) { c.classList.remove('is-active'); });

        this.classList.add('is-active');

        var activeContent = section.querySelector(
          '.single-product-desc-text[data-tab-content="' + target + '"]'
        );
        if (activeContent) activeContent.classList.add('is-active');
      });
    });
  })();

  // --- слайдер картинок ---
  (function () {
    var sliderRoot = section.querySelector('.single-product-left');
    if (!sliderRoot) return;

    var thumbItems = Array.from(
      sliderRoot.querySelectorAll('.single-slider-thumb')
    );
    var mainImage = sliderRoot.querySelector('.single-slider-mainImage img');

    if (!thumbItems.length || !mainImage) return;

    function setActive(index) {
      if (index < 0 || index >= thumbItems.length) return;

      thumbItems.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      var img = thumbItems[index].querySelector('img');
      if (img) {
        mainImage.src = img.src;
        mainImage.alt = img.alt || '';
      }
    }

    thumbItems.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index);
      });
    });

    setActive(0);
  })();

  updateButtonState();
});


